/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Saved_To_ListInputs */

const en_jobs_saved_to_list = /** @type {(inputs: Jobs_Saved_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job saved to your list`)
};

const de_jobs_saved_to_list = /** @type {(inputs: Jobs_Saved_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle in deiner Liste gespeichert`)
};

const fr_jobs_saved_to_list = /** @type {(inputs: Jobs_Saved_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emploi enregistré dans ta liste`)
};

const es_jobs_saved_to_list = /** @type {(inputs: Jobs_Saved_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empleo guardado en su lista`)
};

const it_jobs_saved_to_list = /** @type {(inputs: Jobs_Saved_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavoro salvato nella tua lista`)
};

const nl_jobs_saved_to_list = /** @type {(inputs: Jobs_Saved_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baan opgeslagen in je lijst`)
};

const pl_jobs_saved_to_list = /** @type {(inputs: Jobs_Saved_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta zapisana na Twojej liście`)
};

const fi_jobs_saved_to_list = /** @type {(inputs: Jobs_Saved_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työpaikka tallennettu listaasi`)
};

const da_jobs_saved_to_list = /** @type {(inputs: Jobs_Saved_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job gemt på din liste`)
};

const sv_jobs_saved_to_list = /** @type {(inputs: Jobs_Saved_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobb sparat på din lista`)
};

/**
* | output |
* | --- |
* | "Job saved to your list" |
*
* @param {Jobs_Saved_To_ListInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_saved_to_list = /** @type {((inputs?: Jobs_Saved_To_ListInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Saved_To_ListInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_saved_to_list(inputs)
	if (locale === "fr") return fr_jobs_saved_to_list(inputs)
	if (locale === "es") return es_jobs_saved_to_list(inputs)
	if (locale === "it") return it_jobs_saved_to_list(inputs)
	if (locale === "nl") return nl_jobs_saved_to_list(inputs)
	if (locale === "pl") return pl_jobs_saved_to_list(inputs)
	if (locale === "fi") return fi_jobs_saved_to_list(inputs)
	if (locale === "da") return da_jobs_saved_to_list(inputs)
	if (locale === "sv") return sv_jobs_saved_to_list(inputs)
	return en_jobs_saved_to_list(inputs)
});